/**
 * Title input with optional loading skeleton (URL metadata).
 */
import React from "react";
import InputTextArea from "ui/InputTextArea";
import LoadingSkeleton from "ui/LoadingSkeleton";

export interface TitleFieldProps {
  id: string;
  name: string;
  labelText: string;
  value: string;
  onChange: (value: string) => void;
  maxLength?: number;
  loading?: boolean;
  showSkeletonWhenLoading?: boolean;
  error?: string;
  validationState?: "none" | "valid" | "invalid";
  fieldRequired?: boolean;
}

const TitleField: React.FC<TitleFieldProps> = ({
  id,
  name,
  labelText,
  value,
  onChange,
  maxLength = 300,
  loading = false,
  showSkeletonWhenLoading = true,
  error,
  validationState,
  fieldRequired = false,
}) => (
  <div className="form-control mb-2">
    {loading && showSkeletonWhenLoading && !value ? (
      <LoadingSkeleton count={1} width="w-full" height="h-[60px]" margin="mx-0" className="rounded-2xl" />
    ) : (
      <InputTextArea
        id={id}
        name={name}
        labelText={labelText}
        fieldRequired={fieldRequired}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        maxLength={maxLength}
        error={error}
        validationState={validationState}
      />
    )}
  </div>
);

export default TitleField;
